import axios, { AxiosRequestConfig } from "axios";
import { IRequestOptions } from "@data/model/IRequestOptions";

export default function useAxios(prototype: any, options: IRequestOptions = {}, defaults: AxiosRequestConfig = {}) {
	const merged: AxiosRequestConfig = {...axios.defaults, ...(defaults || {})};
	const common = merged.headers.common || {};
	options = options || {};
	if (options.token) common.authorization = `Basic ${options.token}`;
	merged.headers.common = common;

	if (options.portalId || options.userId) {
		const params = merged.params || {};
		if (options.portalId) params.portalId = options.portalId;
		if (options.userId) params.userId = options.userId;
		merged.params = params;
	}

	axios.defaults = merged;
	prototype.$http = axios;
}
